import { jsx as _jsx } from "react/jsx-runtime";
import { useLottie } from "lottie-react";
import rejectedAnimation from "./rejected-lottie.json";
const style = {
    height: 48,
    width: 48,
};
const RejectedAnimation = () => {
    const options = {
        animationData: rejectedAnimation,
        loop: true,
        autoplay: true,
    };
    const Lottie = useLottie(options, style);
    return (_jsx("div", Object.assign({ style: {
            // height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } }, { children: Lottie.View })));
};
export default RejectedAnimation;
